for (const searchField of document.querySelectorAll('[data-search-in]')) {
    const parent = document.getElementById(searchField.dataset.searchIn);
    const list = parent.querySelectorAll('.searchable-item');

    if (list !== null && list.length > 0) {
        searchField.addEventListener('input', (e) => {
            const searchWord = searchField.value.toLowerCase();
            if (searchWord === '') {
                for (const element of list) {
                    element.hidden = false;
                    const container = element.closest('.searchable-container');
                    container.hidden = container.querySelectorAll('.searchable-item:not([hidden])').length <= 0;
                }
            } else {
                for (const element of list) {
                    element.hidden = element.textContent.toLowerCase().indexOf(searchWord) === -1;
                    const container = element.closest('.searchable-container');
                    container.hidden = container.querySelectorAll('.searchable-item:not([hidden])').length <= 0;
                }
            }
        });
    }
}
